module.exports = __webpack_public_path__ + "static/media/chatbot.d65871cd.svg";